import { render, staticRenderFns } from "./speedDial.vue?vue&type=template&id=e36f0764"
import script from "./speedDial.vue?vue&type=script&lang=js"
export * from "./speedDial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports